import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
// Types
import ITimer from 'models/Timer';
import IPage from 'models/Page';
// Components
import Accordion from 'components/Accordion';
import TimerForm from './TimerForm';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  timerRef: string;
  defaultExpanded?: boolean;
}

const Timer: FC<Props> = ({ timerRef, defaultExpanded }) => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const watchedTimers = watch('timers');
  const watchedPages = watch('pages');
  const pageRef = watchedPages.find((page: IPage) => page.refs.includes(timerRef))?.uuid;

  // Guard: if timer not found yet, render nothing.
  const timerIndex = watchedTimers.findIndex((timer: ITimer) => timer.ref === timerRef);
  if (timerIndex < 0) return null;

  return (
    <div>
      <Accordion
        label={`${t('labels.timer')} ${t('labels.page')}`} icon="stopwatch"
        previewPage="timer" previewPageRef={pageRef}
        defaultExpanded={defaultExpanded}
      >
        <TimerForm timerRef={timerRef} />
      </Accordion>
    </div>
  );
};

export default Timer;
